import type { CSS } from '@stitches/react';
import { ReactNode } from 'react';

import { Grid } from '@/components/shared/layout/grid';

interface ToggleGroupProps {
  css?: CSS;
  children: ReactNode;
}

export const ToggleGroup: React.FC<ToggleGroupProps> = ({
  css,
  children,
}: ToggleGroupProps) => {
  return (
    <Grid
      css={css}
      rowGap={{
        '@initial': '1',
        '@md': '2',
      }}
    >
      {children}
    </Grid>
  );
};

ToggleGroup.displayName = 'ToggleGroup';
